module.exports = __webpack_public_path__ + "static/img/intro3.26f4fadd.png";